import { FaHeart, FaCode } from "react-icons/fa";
import { IoPeopleSharp } from "react-icons/io5";
import { FaQuoteLeft } from "react-icons/fa";
const WhyDoingThisSection = () => {

    const cards = [
        {
            id: 1,
            title: "Passion for Teaching",
            desc: "I've spent 10 years in the trenches, working with startups and enterprises. Now, I want to give back to the community that shaped me. Teaching isn't a side hustle for me — it's a calling",
            icon: <FaHeart size={32} />,
        },
        {
            id: 2,
            title: "Real-World Experience",
            desc: "These aren't textbook theories. Every tip, trick, and practice I share comes from actual projects, actual problems, and actual solutions that worked in production environments",
            icon: <FaCode size={32} />,
        },
        {
            id: 3,
            title: "Building Community",
            desc: "Learning alone is hard. That's why these sessions are about creating a space where developers help each other grow. Ask questions, share experiences, make friends.",
            icon: <IoPeopleSharp size={32} />,
        },
    ];



    return (
        <section className="row mx-0 justify-content-center my-5 py-5">
            <div className="col-12 col-md-10 text-light">
                <div className="row mx-0 justify-content-center mb-5 text-center">
                    <div className="col-10">
                        <h1 className="fw-bold">Why I'm Doing This</h1>
                        <p className="mt-2">
                            Because I remember being where you are, and I wish someone had done this for me.
                        </p>
                    </div>
                </div>

                <div className="row mx-0 d-flex align-items-center mb-5">
                    {cards.map((item) => (
                        <div className="col-12 col-md-4" key={item.id}>
                            <div className="my-1 p-4 border radius-10 h-100">
                                <i className="mb-3 fs-3 text-custom m-3">{item.icon}</i>
                                <h5 className="fw-bold mt-3">{item.title}</h5>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="row mx-0">
                    <div className="col-12">
                        <div className="p-4 radius-10 border d-flex">
                            <i className="mb-3 fs-3 text-custom m-3"><FaQuoteLeft size={32} /></i>
                            <div>
                                <p className="fst-italic mb-2">
                                    “I started coding when tutorials were scarce and mentors were rare.
                                    I struggled through documentation, made countless mistakes, and learned the hard way.
                                    But those struggles taught me what really matters. Now, I want to fast-track your journey —
                                    not by making it easy, but by making it focused on what actually counts.”
                                </p>
                                <p className="mb-0 text-custom fw-bold">
                                    — Akshay Mandliya
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default WhyDoingThisSection;
